import { useOutletContext } from 'react-router-dom'
import { TrocaAutomaticaTabela } from '@/service/api'

export function useTrocaAutomaticaHorarioOutletContext() {
    return useOutletContext<{ data: TrocaAutomaticaTabela[] }>()
}
